import {
  Article,
  Inventory,
  Pages,
  Summarize,
  TableRows,
} from "@mui/icons-material";
import { Avatar, Chip } from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";

type DatasetTypeChipProps = {
  type: string;
  avatar?: boolean;
  fontSize?: number;
  isFolder?: boolean;
};

export const getColorFromType = (type: string) => {
  switch (type) {
    case "document":
      return "primary";
    case "tabular":
      return "success";
    case "ProjectAI":
      return "error";
    case "Activity":
      return "warning";
    case "AtomResults":
      return "secondary";
    default:
      return "primary";
  }
};

export const getIconFromType = (
  type: string,
  avatar: boolean,
  fontSize = 24,
  isFolder?: boolean,
) => {
  const iconSize = avatar ? { sx: { fontSize: fontSize } } : {};
  if (isFolder) {
    return <FolderIcon {...iconSize} color={"primary"} />;
  }
  switch (type) {
    case "document":
      return <Article {...iconSize} color={getColorFromType(type)} />;
    case "tabular":
      return <TableRows {...iconSize} color={getColorFromType(type)} />;
    case "ProjectAI":
      return <Inventory {...iconSize} color={getColorFromType(type)} />;
    case "Activity":
      return <Summarize {...iconSize} color={getColorFromType(type)} />;
    case "AtomResults":
      return <Pages {...iconSize} color={getColorFromType(type)} />;
    default:
      return <Article {...iconSize} />;
  }
};

const DatasetTypeChip = ({
  type,
  avatar = false,
  fontSize = 24,
  isFolder,
}: DatasetTypeChipProps) => {
  const convertTextToTitleCase = (text: string) => {
    return text
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <>
      {avatar && (
        <Avatar
          sx={{
            width: 24,
            height: 20,
            bgcolor: "transparent",
          }}
          variant="rounded"
        >
          {getIconFromType(type, avatar, fontSize, isFolder)}
        </Avatar>
      )}
      {!avatar && (
        <Chip
          label={convertTextToTitleCase(type)}
          color={getColorFromType(type)}
          size="small"
          icon={getIconFromType(type, avatar, fontSize)}
          sx={{ borderRadius: 1 }}
        />
      )}
    </>
  );
};

export default DatasetTypeChip;
